<template>
    <div>
        <h3>Order Status Notifications</h3>
        <el-form>
            <span>CC: of "Order Confirmation" email is sent to</span>
            <el-form-item>
                <el-input
                    :readonly="!can(Permissions.EDIT_NOTIFICATIONS)"
                    style="max-width: 300px"
                    type="email"
                    v-model="form.order_confirmation.cc"
                />
            </el-form-item>
            <span>CC: of "Order Has Shipped" email is sent to</span>
            <el-form-item>
                <el-input
                    :readonly="!can(Permissions.EDIT_NOTIFICATIONS)"
                    style="max-width: 300px"
                    type="email"
                    v-model="form.order_shipped.cc"
                />
            </el-form-item>
            <span>"Digital Display Signup" email is sent to</span>
            <el-form-item>
                <el-input
                    :readonly="!can(Permissions.EDIT_NOTIFICATIONS)"
                    style="max-width: 300px"
                    type="email"
                    v-model="form.digital_display.signup"
                />
            </el-form-item>
            <span>CC: of "Forgot Password" email is sent to</span>
            <el-form-item>
                <el-input
                    :readonly="!can(Permissions.EDIT_NOTIFICATIONS)"
                    style="max-width: 300px"
                    type="email"
                    v-model="form.forgot_password.cc"
                />
            </el-form-item>
        </el-form>
        <el-button
            :loading="form.busy"
            @click="submit()"
            icon="mdi mdi-content-save"
            type="primary"
            v-if="can(Permissions.EDIT_NOTIFICATIONS)"
        >
            Save Changes
        </el-button>
    </div>
</template>

<script>
import auth from "@/mixins/auth";

export default {
    mixins: [auth],
    props: {
        form: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            label1: `CC: of "Order Confirmation" email is sent to`,
            label2: `CC: of "Order Has Shipped" email is sent to`,
        };
    },
    mounted() {
        //
    },
    computed: {
        //
    },
    methods: {
        submit() {
            App.put(`/web-api/setting/notification`, this.form).then(() => {
                this.$notify.success({
                    message: `Changes have been saved.`,
                });
            });
        },
    },
};
</script>

<style scoped></style>
